
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.979","height":"12.202"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.947 3.693v6.868a1.538 1.538 0 00.409 1.061 1.373 1.373 0 001 .431h5.27a1.372 1.372 0 001-.431 1.538 1.538 0 00.409-1.061V3.693a1.065 1.065 0 00-.273-2.094H7.331v-.348a1.095 1.095 0 00-1.1-1.1h-2.48a1.095 1.095 0 00-1.1 1.1v.348H1.22a1.065 1.065 0 00-.273 2.094zm6.679 7.8H2.352a.883.883 0 01-.847-.934V3.718h6.968v6.843a.883.883 0 01-.847.934zM3.204 1.251A.537.537 0 013.75.707h2.477a.537.537 0 01.546.544v.348H3.204zm-1.985.906h7.539a.5.5 0 110 1H1.22a.5.5 0 110-1z","fill":"#6a7685","stroke":"#6b7786","stroke-width":".3"}})])
          )
        }
      }
    